<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { ParameterCardV2 } from '@Shelly/shelly-design-system/index';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { mapIconToThin } from 'src/helpers/new-layout-helpers';

	export let statuses = [];

	$: mainLabel = Array.isArray(statuses) ? statuses.find((i) => i.mainLabel) : undefined;
</script>

{#if mainLabel}
	<ParameterCardV2
		icon={mapIconToThin(mainLabel.icon)}
		iconColor={mainLabel?.iconColor || ''}
		title={capFirstChar(mainLabel.value)}
		description={capFirstChar(
			$format(`title_chart_${mainLabel.peripheralType}`, {
				default: mainLabel.peripheralType,
			}) || '',
		)}
	/>
{/if}
